import { ScopeContext } from './ScopeContext';

interface ScopedProps {
    scope: string;
}

const withScopeContext =
    <T extends ScopedProps>(Component: React.ComponentType<T>) =>
    (props: Omit<T, 'scope'>) => (
        // @ts-expect-error $TSFixMeError: Type 'Omit<T, "scope"> & { scope: string | undefined; }' is not assignable to type 'IntrinsicAttributes & T & { children...
        <ScopeContext.Consumer>{(context) => <Component {...props} scope={context} />}</ScopeContext.Consumer>
    );

export default withScopeContext;
